import { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash, FaCamera } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const LogIn = ({ dark, setUser, MyBaseUrl }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);


  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const setCookie = (name, value, days = 50) => {
    const expires = new Date(
      Date.now() + days * 24 * 60 * 60 * 1000
    ).toUTCString();

    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; expires=${expires}; path=/`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    try {
      setLoading(true);

      const res = await fetch(
        `${MyBaseUrl}/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await res.json();

      if (!res.ok || data.status !== "success") {
        throw new Error(
          data.message || "Login failed"
        );
      }

      const token = data?.data?.token;
      const user = data?.data?.user;

      if (token) {
        localStorage.setItem("authToken", token);
        localStorage.setItem(
          "authUser",
          JSON.stringify(user)
        );

        setCookie("authToken", token, 50);
      }

      // ✅ FIXED HERE
      if (setUser) {
        setUser({
          ...user,
          token: token,
        });
      }

      const redirectTo =
        location.state?.from?.pathname || "/";

      navigate(redirectTo, { replace: true });
    } catch (err) {
      setErrorMsg(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (

    <>

      <Helmet>
        <title>Login | Goal Arena</title>
        <meta
          name="description"
          content="Login to your Goal Arena account to access personalized football updates, news, and live matches."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="homer">
        <section className="signup-container">
          <form
            onSubmit={handleSubmit}
            className="signup-card"
            style={
              dark
                ? { background: "#14141471" }
                : {}
            }
          >
            <h1
              style={
                dark ? {} : { color: "#161819" }
              }
            >
              Welcome Back ⚽
            </h1>

            {errorMsg && (
              <p style={{ color: "red" }}>
                {errorMsg}
              </p>
            )}

            <input
              type="email"
              name="email"
              placeholder="Email"
              onChange={handleChange}
              required
              style={
                dark
                  ? {
                      backgroundColor: "#111111e7",
                      color: "white",
                      border:
                        "1px solid #3a3a3a79",
                    }
                  : {}
              }
            />

            <div
              style={
                dark
                  ? {
                      background: "#111111e7",
                      color: "white",
                      border: "unset",
                      outline: "unset",
                      position: "relative",
                      width: "100%",
                      borderRadius: "8px",
                    }
                  : { position: "relative", width: "100%" }
              }
              className="inn"
            >
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                onChange={handleChange}
                required
                style={{
                  backgroundColor: "transparent",
                  width: "100%",
                  paddingRight: "45px",
                  border: "unset",
                  outline: "unset",
                  color: dark ? "white" : "#161819",
                }}
              />

              <span
                onClick={() =>
                  setShowPassword(!showPassword)
                }
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#888",
                  display: "flex",
                  alignItems: "center",
                  scale: "0.8",
                }}
              >
                {showPassword ? (
                  <FaEyeSlash />
                ) : (
                  <FaEye />
                )}
              </span>
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>

            <p
              style={
                dark ? {} : { color: "#3e3f3f" }
              }
            >
              Don’t have an account?{" "}
              <NavLink to="/signup"
                state={{ from: location.state?.from }}>
                <span>Sign Up</span>
              </NavLink>
            </p>
          </form>
        </section>

       
      </div>
    </>
  );
};

export default LogIn;